import React , { useEffect}from 'react'

import { TabMenu } from 'primereact/tabmenu'
import { Menubar } from 'primereact/menubar';
//import { MenuItem } from 'primereact/menuitem'
import { useNavigate } from 'react-router-dom';

function LandingPage( { data }) { // Sin login data esta en null

  const navigate = useNavigate();


  useEffect( () => {

    console.log( "data en landing page = " , data )

  } , [data] )

  function busqueda()
  {

    console.log("data en busqueda = ", data)

    if ( data=== null || data === undefined )
    {
      alert("No se tiene permiso")
      return ;
    }

    navigate('/search')

  }

  const items = [
    {label: 'Home', icon: 'pi pi-fw pi-home' , url : '/'},
    {label: 'Login', icon: 'pi pi-fw pi-user' ,  url : '/'},
    {label: 'Cargar Datos', icon: 'pi pi-fw pi-file-export' , command : () => { data?.iduserrole === 1 ? navigate('/upload') : alert( "No se tiene permiso") }},
    {label: 'Mover Datos', icon: 'pi pi-fw pi-file-export' ,
      
      items: [
        {
            label: 'Enviar a Produccion',
            icon: 'pi pi-bolt' ,
            command : () => { data?.iduserrole === 1 ? navigate('/move'): alert( "No se tiene permiso")}
        },
        {
          label: 'Ver repetidos',
          icon: 'pi pi-server' ,
          command : () => { data?.iduserrole === 1 ?  navigate('/moverep'): alert("No se tiene permiso")}
        } ,

        {
          label: 'Ver agrupados',
          icon: 'pi pi-table' ,
          command : () => { data?.iduserrole === 1 ?  navigate('/grouped'): alert("No se tiene permiso")}
        } 
    
        
      
      ] } ,
    {label: 'Buscar', icon: 'pi pi-fw pi-search'  , command : () => busqueda() /*command : () => navigate('/search') }*/},  // pi-sign-out
    {label: 'Logout', icon: 'pi pi-fw pi-sign-out' , url : '/'},
    {label: 'Settings', icon: 'pi pi-fw pi-cog'}
  ];




  return (
    <>
    
      <h2 >Digital Shop Center &nbsp;&nbsp; <span style={{fontSize:'15px'}}>Consulta de base Call center</span></h2>

      <div className='card'>

        <Menubar model={items} />

      </div>
    
    </>
  )
}

export default LandingPage